import SectionWithItems from "../../../scripts/SectionWithItems";
import deadlocket from "../../../data/deadlocket";

const projects = [
    deadlocket,
    {
        "left": "Sea of Marbles",
        "right": "",
        "image": "/images/bandletech/sea-of-marbles-1.jpg",
        "parallax1": -200,
        "parallax2": 200,
        "link": "/projects/sea-of-marbles"
    },
];

const LatestProjects = () => {
    return (
        <SectionWithItems title='Latest Projects' projects={projects} extraLink="/projects" />
    );
};

export default LatestProjects;
